import TLP from "./TelaListarPadrao.vue";
import TEP from "./TelaEditarPadrao.vue";
import AcoesDropDown from "./AcoesDropDown.vue";

export const HcAcoesDropDown = AcoesDropDown;
export const TelaListarPadrao = TLP;
export const TelaEditarPadrao = TEP;
